import React from 'react'
import { Button } from 'react-bootstrap'
import Modal from '../../modals/wrapper'
import Logs from './logs'
import useJob from '../../../hooks/use-job'
import { describeSchedule, JOB_TIME_ZONE } from '../job-schedule'

const JobModal = ({
    job = {},
    onHide = () => {},
}) => {

    const {
        id,
        name,
        description,
        schedule,
    } = job

    const { runJob, isRunning } = useJob({ jobId: id })

    return (
        <Modal
            closeButton
            onHide={onHide}
            fullWidth
        >
            <div style={{
                padding: '20px',
                minHeight: '400px'
            }}>
                <h4>{name}</h4>
                <div>{description}</div>
                <div className='mb-2'>
                    Schedule: {describeSchedule(job)}
                    {schedule ? (<small className='text-muted'> ({schedule}, {JOB_TIME_ZONE} time)</small>) : null}
                </div>
                <Button onClick={ () => runJob()} disabled={isRunning}>Run Now</Button>
                <hr />
                <div>Logs:</div>
                <div>
                    <Logs job={job} />
                </div>
            </div>
        </Modal>
    )
}

export default JobModal